import { ModalContent } from './modal-content';
import { ServiceHistoryModalProps } from './types';
import { InlineSvg } from 'components/svg';
import useLockScroll from 'hooks/use-lock-scroll';
import { FC } from 'react';

export const ServiceHistoryModal: FC<ServiceHistoryModalProps> = ({ regNo, vin, onClose }) => {
  useLockScroll();

  return (
    <>
      <div className="modal fade show d-block" id="kt_modal" role="dialog" tabIndex={-1} aria-modal="true">
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content">
            <div className="modal-header mb-0 pb-0">
              <h2 className="fw-bolder">Vehicle Service History</h2>
              <div
                className="btn btn-icon btn-sm btn-active-icon-primary"
                onClick={onClose}
                style={{ cursor: 'pointer' }}
              >
                <InlineSvg path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-1" />
              </div>
            </div>
            <div className="modal-body scroll-y pb-8 pt-0">
              <ModalContent regNo={regNo} vin={vin} onClose={onClose} />
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
};
